// 回放日曆（PLAY-01）：月曆格子與事件密度條的純函式。

/** 'YYYY-MM' 這個月的格子：前面補到週一（null），每格 'YYYY-MM-DD'。 */
export function monthCells(month: string): (string | null)[] {
  const [y, m] = month.split('-').map(Number);
  const first = new Date(Date.UTC(y, m - 1, 1));
  const days = new Date(Date.UTC(y, m, 0)).getUTCDate();
  const lead = (first.getUTCDay() + 6) % 7; // 週一 = 0
  const out: (string | null)[] = Array(lead).fill(null);
  for (let d = 1; d <= days; d++) out.push(`${month}-${String(d).padStart(2, '0')}`);
  return out;
}

export function addMonths(month: string, n: number): string {
  const [y, m] = month.split('-').map(Number);
  const d = new Date(Date.UTC(y, m - 1 + n, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

/**
 * 事件密度條：把可視範圍切成 buckets 等分，回每一格的事件數與 0–1 的強度（對最大值）。
 * 事件在 [from, from + span) 之外的不算。
 */
export function eventDensity(ts: number[], from: number, span: number, buckets: number): { n: number; level: number }[] {
  const counts = Array(buckets).fill(0) as number[];
  for (const t of ts) {
    if (t < from || t >= from + span) continue;
    counts[Math.min(buckets - 1, Math.floor(((t - from) / span) * buckets))]++;
  }
  const max = Math.max(1, ...counts);
  return counts.map((n) => ({ n, level: n / max }));
}
